<template>
  <div class="l-learn-question-container l-learn-exam-wrapper" v-show="isRefresh" v-if="element">
    <div class="l-learn-question-wrapper l-back-wrapper l-learn-exam-top">
      <div class="l-learn-question-inner" id="l-learn-question-inner">
        <!-- 题目序号 -->
        <div class="l-learn-question-number">{{ currentIndex + 1 }}</div>
        <!-- 题目 -->
        <div class="l-learn-question-main" id="l-learn-question-main" :style="{ height: examHeight + 'px' }">
          <div class="l-learn-question-stem" v-html="currentItemData.attrs.questionText"></div>
          <div class="l-learn-question-selection">
            <div class="l-learn-question-item" :class="{
              active: element.records && element.records[currentIndex]
                ? element.records[currentIndex].option ==
                item.index
                : false,
            }" v-for="(item, index) in currentItemData.options" :key="index" @click="onSelect(item)">
              <div class="l-learn-question-item-main">
                <div class="l-learn-question-label">{{ String.fromCharCode(65 + index) }}</div>
                <div class="l-learn-question-text" v-html="item.option"></div>
              </div>
            </div>
          </div>
        </div>
        <!-- 答题卡按钮 -->
        <button type="button" class="l-learn-question-card-btn" @click="onGoCard"></button>
        <!-- number -->
        <LNumber :current="currentIndex + 1" :total="element.totalCount" :myclass="'test'" class="l-learn-number" />
        <!-- time -->
        <LTime :time="time" class="l-learn-time" />
      </div>

      <!-- 按钮 -->
      <!-- <div class="l-learn-exam-btn-container l-learn-exam-bottom" v-if="
        !isLast && currentIndex < element.records.length - 1
      ">-->
      <!-- 当天题号小于答案题号 -->
      <!-- <LButtonCommon :type="3" @select="onContinue" />
      </div>-->

      <div class="l-learn-exam-btn-container l-learn-exam-bottom">
        <!-- 上一题 -->
        <LButtonCommon :type="5" :status="isFirst ? 0 : 1" :text="$locale.上一题" @select="onPreItem" />
        <!-- 下一题 -->
        <LButtonCommon :type="5" :status="isLast || isSort ? 0 : 1" :text="$locale.下一题" @select="onNextItem" />
        <!-- 做完题展示 -->
        <LButtonCommon v-if="isLast && isDone" :type="4" :text="$locale.提交" @select="onSubmit" />
      </div>
    </div>
  </div>
</template>

<script>
import LNumber from '../../../../components/l-number'
import LTime from '../../../../components/l-time'
import LButtonCommon from '@/views/learn-new/components/l-button-common'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('course')

export default {
  name: 'l-learn-question',
  components: { LNumber, LTime, LButtonCommon },
  props: {
    currentIndex: {
      type: Number,
    },
    time: [String],
  },
  data() {
    return {
      examIndex: 0, // 当前题题号
      isRefresh: true,
      examHeight: '100%', // 问题高度
      currentItemData: null,
    }
  },
  computed: {
    ...mapGetters(['element']),
    isFirst() {
      return this.currentIndex == 0
    },
    isLast() {
      return this.currentIndex + 1 >= this.element.totalCount
    },
    isSort() {
      return (
        this.element.records &&
        this.currentIndex === this.element.records.length
      )
    },
    isDone() {
      return this.element.records ? this.element.records.length === this.element.datas.length : false
    }
  },
  watch: {
    currentIndex: {
      handler() {
        this._composeItem()
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this._composeItem()
  },
  mounted() {
    let _this = this
    window.onresize = () => {
      _this._setHeight()
    }
    _this._setHeight()
  },
  destroyed() {
    window.onresize = null
  },
  methods: {
    // 选择答案
    onSelect(optionItem) {
      const option = optionItem.index
      const answer = {
        option,
        eleId: this.currentItemData.id,
        right: this._isRight(option),
        suggestedScore: this._isRight(option) ? 100 : 0,
      }

      // 修改
      if (
        this.element.records &&
        (this.currentIndex < this.element.records.length - 1 ||
          this.element.records[this.currentIndex])
      ) {
        answer.id = this.element.records[this.currentIndex].id
      }

      this.$emit('select', {
        index: this.currentIndex,
        answer,
      })
    },
    onNextItem() {
      if (this.currentIndex >= this.element.records.length) {
        return
      }
      this._nextItem()
    },
    onPreItem() {
      this._preItem()
    },
    // 提交
    onSubmit() {
      this.$emit('submit')
    },
    // 跳转到答题卡
    onGoCard() {
      this.$emit('toggle')
      this._composeItem()
    },
    // 点击继续作答
    onContinue() {
      this.$emit('jump', this.element.records.length)
    },
    _splitString(str) {
      var regex = /<p>([\s\S]*?)<\/p>/g;
      var matches = str.match(regex);
      if (!matches) {
        return [];
      }

      var filteredMatches = matches.filter(function(match) {
        return /[A-Z]/.test(match);
      });

      // 提取选项索引和选项内容
      var options = filteredMatches.map(function(match) {
        // 删掉选项里的HTML标签
        const noHtmlOption = match.replace(/<[^>]*>/g, '').trim()
        // 去掉选项前的空格&nbsp;等
        const noSpaceOption = noHtmlOption.replace(/&nbsp;/g, ' ').trim();
        // 提取选项索引
        var index = noSpaceOption.charAt(0);
        // 去掉选项前的ABC等字母索引'A'|'A.'|'A．'等
        const option = noSpaceOption.replace(/^[A-Z][\.．:]?\s*/, '');
        return { index, option, };
      });

      // 打乱选项顺序
      options = this.shuffle(options);

      return options;
    },
    // 打乱数组顺序的函数
    shuffle(array) {
      var currentIndex = array.length, temporaryValue, randomIndex;

      while (0 !== currentIndex) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }

      return array;
    },
    _composeItem() {
      const currentItem = this.element.datas[this.currentIndex]
      const realOptions = this._splitString(currentItem.attrs.selectionText)
      this.currentItemData = {
        ...this.element.datas[this.currentIndex],
        options: realOptions,
      }

      this._scrollToTop()
    },
    _nextItem() {
      this.$emit('next-item')
    },
    _preItem() {
      this.$emit('pre-item')
    },
    // 题目滚动到顶部
    _scrollToTop() {
      if (document.getElementById('l-learn-question-main')) {
        document.getElementById('l-learn-question-main').scrollTop = 0
      }
    },
    // 设置高度
    _setHeight() {
      this.examHeight = document.documentElement.clientHeight * 0.55
    },
    _isRight(option) {
      let b = false
      for (
        let i = 0;
        i < this.currentItemData.attrs.selectionList.length;
        i++
      ) {
        if (this.currentItemData.attrs.selectionList[i].name === option) {
          b = !!this.currentItemData.attrs.selectionList[i].isRight
          break
        }
      }

      return b
    },
  },
}
</script>

<style lang="stylus" scoped>
@import './index.styl'
</style>
